import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import { Toaster } from "sonner";

import Landing from "@/pages/Landing";

axios.defaults.withCredentials = true;

function App() {
  return (
    <div className="App grain">
      <Toaster theme="dark" position="top-center" toastOptions={{ style: { background: "#0C0C0C", color: "#fff", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 0 } }} />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
